"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.dashboard.heading': '内容规划中心',
    'socialMediaPlan.dashboard.desc': '创建内容，选择渠道，计划发布。',
};
